<template>
    <select :id="id" :name="name" class="form-control form-control--select" :class="className" :tabindex="tabindex" @change="onChangeItem">
        <template v-if="hasPlaceholder">
            <option value="">{{ placeholder }}</option>
        </template>
        <template v-for="item in items">
            <option :value="item.id" :selected="isSelectedItem(item.id)">{{ item.title }}</option>
        </template>
    </select>
</template>

<script>
    export default {
        props : {
            id : {
                type : String,
                default : ''
            },
            name : {
                type : String,
                default : 'country_code'
            },
            value : {
                type : [String, Number],
                default : 'de'
            },
            placeholder : {
                type : String,
                default : ''
            },
            className : {
                type : String,
                default : ''
            },
            tabindex : {
                type : [String, Number],
                default : ''
            },
            dachCountriesOnly : {
                type : [Boolean],
                default : false
            },
        },
        data() {
            return {
                items   : this.getItems()
            }
        },
        computed : {
            hasPlaceholder : function () {
                return this.placeholder !== '';
            }
        },
        methods : {
            getItems : function () {
                var countries = [];

                for (var countryCode in this.$helpers.countries) {
                    if (!this.dachCountriesOnly || this.isDachCountryCode(countryCode)) {
                        countries.push({
                            id      : countryCode,
                            title   : this.$helpers.countries[countryCode]
                        });
                    }
                }

                return countries;
            },

            isDachCountryCode(countryCode) {
                return ['de', 'at', 'ch'].includes(countryCode);
            },

            onSelectItem : function (id) {
                this.$emit('input', id);
                this.$emit('change', this.getItemById(id));
            },
            onChangeItem : function (event) {
                this.onSelectItem(event.currentTarget.value);
            },
            isSelectedItem : function (id) {
                return this.value === id;
            },
            getItemById : function (id) {
                var output = null;

                this.items.forEach((function (item) {
                    if (item.id === id) {
                        output = item;
                    }
                }).bind(this));

                return output;
            }
        }
    };
</script>
